/**
 * REST 클라이언트(`main.tsx` 의 `configureAuthApi`)와 STOMP 주소가 같은 값을 쓰도록
 * 여기 한 곳에서만 만든다. WebSocket 은 REST 클라이언트를 타지 않아 `baseURL` 을
 * 물려받지 못하므로, 양쪽이 이 상수를 가져가야 갈라지지 않는다.
 */
const contextPath = import.meta.env.VITE_CONTEXT_PATH || "";
export const API_BASE_URL = `${import.meta.env.VITE_API_BASE_PATH ?? contextPath}/api`;

/** 이벤트 버퍼 최대 크기 */
export const MAX_EVENTS = 200;

export const DASHBOARD_REFRESH_MS = 60_000;

/**
 * 현장 ID가 녹화영상(playback) 제공 대상인지 확인.
 *
 * 과거에는 일부 현장만 허용하는 하드코딩 목록([15, 17, 18])을 썼으나, 백엔드 playback은
 * NVR 타입(Hikvision/Wisenet) 무관하게 동작하므로 NVR이 연결된 모든 현장에서 활성화한다.
 * (개별 NVR/카메라 접근 실패는 재생 요청 시 에러로 처리)
 */
export function isPlaybackEnabledSite(siteId: number | string | undefined | null): boolean {
  if (siteId == null) return false;
  const id = typeof siteId === "string" ? Number(siteId) : siteId;
  return Number.isFinite(id);
}
